<template>
  <v-container
    fluid
    class="vendor-overview d-flex px-0 justify-space-around flex-wrap flex-md-nowrap flex-lg-nowrap"
  >
    <v-card
      v-if="!isOther"
      class="rounded-xl"
      elevation="0"
      outlined
      width="100%"
    >
      <v-card-title
          ><v-container class="overview-card-title text-center red--text py-0">Balance</v-container>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="5" class="text-h6">Balance</v-col>
          <v-col class="text-right text-h6" cols="7">
            <span>{{ currencySymbol }}</span
            ><span>
              {{ convertToCleanNumber(overview.totalAmount, true) }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card
      v-if="!isOther"
      class="rounded-xl"
      elevation="0"
      outlined
      width="100%"
    >
      <v-card-title
          ><v-container class="overview-card-title text-center red--text py-0"
          >Total Stock
          <span class="ml-1">({{ overview.totalStock }})</span></v-container
        >
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="5" class="text-h6">Stock Amount</v-col>
          <v-col class="text-right text-h6" cols="7">
            <span>{{ currencySymbol }}</span
            ><span>
              {{ convertToCleanNumber(overview.stockAmount, true) }}
            </span>
          </v-col>
        </v-row></v-card-text
      >
    </v-card>
    <v-card class="rounded-xl" elevation="0" outlined width="100%">
      <v-card-title
        ><v-container class="overview-card-title text-center red--text py-0"
          >Total Expense
          <span class="ml-1">({{ overview.totalExpense }})</span></v-container
        >
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="5" class="text-h6">Expense Amount </v-col>
          <v-col class="text-right text-h6" cols="7">
            <span>{{ currencySymbol }}</span
            ><span>
              {{ convertToCleanNumber(overview.expenseAmount, true) }}
            </span>
          </v-col>
        </v-row></v-card-text
      >
    </v-card>
  </v-container>
</template>
<script>
import Decimal from "decimal.js";
import generalMixin from "@/js/general-mixin.js";
export default {
  name: "DashboardOverview",
  mixins: [generalMixin],
  components: {},
  props: {
    stocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
    expenses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isOther: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  computed: {
    overview() {
      let overview = {};
      let totalAmount = new Decimal(0);
      let stockAmount = new Decimal(0);
      let expenseAmount = new Decimal(0);
      let totalStock = 0;
      let totalExpense = 0;
      for (let i = 0; i < this.stocks.length; i++) {
        const stock = this.stocks[i];

        const subtotal = Decimal.mul(stock.stockPrice, stock.quantity);
        stockAmount = stockAmount.plus(subtotal);
        totalAmount = totalAmount.plus(subtotal);
      }
      for (let i = 0; i < this.expenses.length; i++) {
        const expense = this.expenses[i];
        const subtotal = new Decimal(expense.amount);
        expenseAmount = expenseAmount.plus(subtotal);
        totalAmount = totalAmount.minus(subtotal);
      }
      totalStock = this.stocks.length;
      totalExpense = this.expenses.length;
      overview = {
        stockAmount,
        expenseAmount,
        totalExpense,
        totalStock,
        totalAmount,
      };
      return overview;
    },
    currencySymbol() {
      return "$";
    },
  },
  methods: {},
};
</script>
<style scoped>
.vendor-overview {
  gap: 8px;
  max-width: none;
  width: 100%;
}
.overview-card-title {
  font-size: 16px;
  font-weight: 500;
}
</style>
